import _getHumanDuration, {
  getHumanDurationInHours as _getHumanDurationInHours,
  getHumanDurationShorthand as _getHumanDurationShorthand,
  roundToMinutes,
} from '@/utils/time/getHumanDuration';

const getHumanDuration = (durationInSeconds?: number | null, colonNotation: boolean = false) =>
  _getHumanDuration(Math.max(roundToMinutes(durationInSeconds), 60), colonNotation);

export const getHumanDurationShorthand = (durationInSeconds?: number | null) =>
  _getHumanDurationShorthand(Math.max(roundToMinutes(durationInSeconds), 60));

export const getHumanDurationInHours = (durationInSeconds?: number | null) =>
  _getHumanDurationInHours(Math.max(roundToMinutes(durationInSeconds), 60));

export default getHumanDuration;
